module.exports = __webpack_public_path__ + "img/20220624161834.361069ce.png";